import SlotWrapper from '../../lib/slot_wrapper';
import Constants from '../../lib/constants';
import { SLOT_TYPES } from './install';
import GamAdPreviewSlot from '../../lib/slots/concert_preview_slot';

export function registerMixin(ConcertAds) {
  ConcertAds.prototype.registerSlot = function(config) {
    const SlotClass = Constants.CONCERT_PREVIEW ? GamAdPreviewSlot : SLOT_TYPES.find(s => s.isSlotTypeFor(config));

    let slot = new SlotClass(this, config);
    slot.wrapper = SlotWrapper.newFromExistingSlot(slot);

    this.slots.push(slot);

    // Consider this slot for first-slot designation (and the response gate's timer) before inserted() runs.
    this.considerSlotForGates(slot);

    slot.inserted();

    return slot;
  };

  /**
   * Look up a registered slot by DOM element id (`slot.id`). Returns the Slot or undefined.
   * E.g. `app.getSlotById(divId).display()`.
   * @param  {string} divId
   * @return {Slot|undefined}
   */
  ConcertAds.prototype.getSlotById = function(divId) {
    return this.slots.all().find(slot => slot.id === divId);
  };
}
